export const isExternalLink = (url: string) => /^https?:\/\//.test(url);
